import { getGlobalSubscriptionState } from '../analytics/shared';
import {
  ACTIVE,
  RADIO_CONTAINER_SELECTOR,
  RADIO_EXTRA_INFO_CONTAINER,
  RADIO_SELECTOR
} from '../classnames/design-system';

export default class Radio {
  updateRadioContainers = (_purchaseType, _radioContainers) => {
    const radioContainers = document.querySelectorAll('.above-the-fold-v3__purchase-type');
    const purchaseType = _purchaseType || getGlobalSubscriptionState();

    radioContainers.forEach((radioContainer) => {
      if (radioContainer.dataset.purchaseType === purchaseType) {
        radioContainer.classList.add(ACTIVE);
      } else {
        radioContainer.classList.remove(ACTIVE);
      }
    });
  };

  handle = () => {
    this.updateRadioContainers();
  };

  handleClick = ({ currentTarget }, container) => {
    this.removeSelection(currentTarget, container);
    this.addSelection(currentTarget, container);

    const purchaseType = currentTarget.getAttribute('value')
      || currentTarget.previousElementSibling.getAttribute('value');

    this.updateRadioContainers(purchaseType);
  };

  removeSelection = (element, container) => {
    const name = element.getAttribute('name');
    const siblings = container.querySelectorAll(`${RADIO_SELECTOR}[name=${name}]`);

    [...siblings].forEach((siblingElement) => siblingElement.setAttribute('selected', false));
  };

  addSelection = (element, container) => {
    const value = element.getAttribute('value');
    const name = element.getAttribute('name');
    const selectedElements = container.querySelectorAll(`${RADIO_SELECTOR}[name=${name}][value="${value}"]`);

    [...selectedElements].forEach((selectedElement) => selectedElement.setAttribute('selected', true));
  };

  getValueByName = (name, container = document) => {
    const selectedOption = this.getSelectedOptionByName(name, container);

    if (!selectedOption) {
      return null;
    }

    return selectedOption.getAttribute('value');
  };

  getDataByName = (name, container = document) => {
    const selectedOption = this.getSelectedOptionByName(name, container);

    if (!selectedOption) {
      return null;
    }

    return selectedOption.dataset;
  };

  getSelectedOptionByName = (name, container = document) => (
    container.querySelector(`${RADIO_SELECTOR}[name=${name}][selected=true]`)
  );

  initializeEventListeners = () => {
    this.containers = [...document.querySelectorAll(RADIO_CONTAINER_SELECTOR)];

    this.containers.forEach((container) => {
      const inputs = [...container.querySelectorAll(RADIO_SELECTOR)];

      inputs.forEach((element) => element.addEventListener('click', (event) => {
        const isClickableBlock = event.currentTarget.classList.contains(RADIO_EXTRA_INFO_CONTAINER);
        const isPopupIcon = event.target.dataset.icon;

        // TODO - wtf is going on? We don't know anything about storage and state here! It DESIGN-SYSTEM radio btn!
        // Rethink and move to an appropriate place!
        if (isClickableBlock && !isPopupIcon) {
          window.currentVariantStorage.setSubscription('subscription');
        }

        this.handleClick(event, container);
      }, true));
    });

    window.currentVariantStorage.subscribe(this);
  };
}
